import { useTranslation } from 'react-i18next'
import { TemplateList } from './TemplateList'

export function TemplatesView() {
  const { t } = useTranslation('templates')

  return (
    <div className="px-4 pt-4 pb-24">
      <h1 className="text-xl font-bold text-ink mb-4">{t('title')}</h1>
      <TemplateList />
    </div>
  )
}
